import Vue from 'vue';
import { prefixCss } from 'plant-common/src/utils';
import defaultCss from 'plant-common/src/components/plant-item-viewer/styleSheet/defaultCss';

export function createStyleSheetController(vueModel) {
	return new Vue({
		data() {
			return {
				vueModel,
				cssContent: null,
				styleTargetId: 'ib-prosemirror-for-css'
			};
		},
		computed: {
			$contents() {
				return this.vueModel.value.body.contents;
			},
			$styleTagId() {
				return `${this.styleTargetId}-${this.vueModel.value.header.metadata.content_id}`;
			},
			$isIB() {
				return this.vueModel.value.header.metadata.content_revision_type === 'interactiveBook';
			}
		},
		created() {
			// TODO: move this functionality to Interactive Book component
			if (this.$isIB && !this.$contents.objectives) {
				this.$set(this.$contents, 'objectives', []);
			}

			if (this.$isIB && !this.$contents.settings.styles.css) {
				this.$set(this.$contents.settings.styles, 'css', defaultCss);
			}

			if (this.$isIB && this.$contents.settings.styles.css) {
				this.applyStyleSheet();
			}
		},
		methods: {
			$prefixCss: prefixCss,
			$getStyleTag() {
				let styleTag = document.getElementById(this.$styleTagId);

				if (!styleTag) {
					styleTag = document.createElement('style');
					styleTag.id = this.$styleTagId;
					styleTag.type = 'text/css';
				}

				return styleTag;
			},

			async $getCssFromStyleSheet() {
				if (typeof this.$contents.settings.styles.css === 'object') {
					const res = await fetch(this.$contents.settings.styles.css.body.contents.attachment.url);
					return res.ok ? await res.text() : '';
				}

				if (typeof this.$contents.settings.styles.css === 'string') {
					return this.$contents.settings.styles.css;
				}
			},
			async applyStyleSheet() {
				const styleTag = this.$getStyleTag();
				document.head.appendChild(styleTag);

				this.cssContent = await this.$getCssFromStyleSheet();

				const mediaPrintAndScreenCss = `@media print, screen {
					${this.$prefixCss(this.cssContent, this.styleTargetId)}
				}`;

				styleTag.innerHTML = mediaPrintAndScreenCss;
			},
			setStyleSheet(styleSheet) {
				this.vueModel.value.body.contents.settings.styles.css = styleSheet ? styleSheet : defaultCss;
				this.applyStyleSheet();
			}
		}
	});
}
